import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * H4 heading component
 * Block-level heading component for smaller section titles
 */
const H4 = ({ children, ...props }) => {
  return (
    <Typography variant="h4" component="h4" {...props}>
      {children}
    </Typography>
  );
};

H4.propTypes = {
  children: PropTypes.node.isRequired,
};

export default H4;
